import Styles from './QuizForNode.module.scss';
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Module imports.
import axios from 'axios';
import { Tab, Tabs, Tooltip, Backdrop } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

// Components import.
import { useAPI } from 'components/lib';
import { QuizQuestion } from 'components/global/QuizQuestion/QuizQuestion';
import { LoadingBackdrop } from 'components/global/LoadingBackdrop/LoadingBackdrop';

export function NodeQuiz(props) {

	const { lab_id, node_id } = useParams();
	const { context } = useParams();
	const navigate = useNavigate();

	const [questions, setQuestions] = useState([]);
	const [selectedAnswers, setSelectedAnswers] = useState([]);
	const [tabIndex, setTabIndex] = useState(0);
	const [quizName, setQuizName] = useState('');
	const [apiURL, setAPIURL] = useState('');
	const [isResults, setIsResults] = useState(context === 'results');

	useEffect(() => {
		if (context === 'results') {
			setIsResults(true);
			setAPIURL(`/api/labs/${lab_id}/nodes/${node_id}/quiz/results`);
		}
		if (context === 'attempt') {
			setAPIURL(`/api/labs/${lab_id}/nodes/${node_id}/quiz`);
		}
		if (context !== 'attempt' && context !== 'results') {
			navigate('/404');
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isResults]);

	const { data, loading } = useAPI(apiURL, 'GET');

	useEffect(() => {
		if (data?.length) {
			if (isResults) {
				setQuestions(data[0].answers);
				// setScore(data[0].score)
				// setPercentage(data[0].percentage)
				setQuizName(data[0].name);
			} else {
				setQuestions(data[0].questions);
				const newSelectedAnswers = Array.from({ length: data[0].questions.length }, () => -1);
				setSelectedAnswers(newSelectedAnswers);
				setQuizName(data[0].name);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	// Pop-up for reload 
	useEffect(() => {
		const handleBeforeUnload = (event) => {
			event.preventDefault();
			const message = props.t('Labs.QuizForNode.preventDefault.back');
			event.returnValue = message;
			return message;
		};

		const handlePageLeave = () => {
			return props.t('Labs.QuizForNode.preventDefault.close');
		};

		window.addEventListener('beforeunload', handleBeforeUnload);
		window.addEventListener('unload', handlePageLeave);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
			window.removeEventListener('unload', handlePageLeave);
		};

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const tabLabels = questions.map((_, index) => (
		<div id={`tabCircle-${index}`} key={index} className={Styles.tabCircle}>
			{index + 1}
		</div>
	));

	const handleTabChange = (event, newTabIndex) => {
		setTabIndex(newTabIndex);
	};

	const handleAnswerSelect = (orderId, questId, selectedOption) => {
		setSelectedAnswers((prevSelectedAnswers) => {
			const updatedSelectedAnswers = [...prevSelectedAnswers];

			updatedSelectedAnswers[orderId] = {
				question_id: questId,
				selectedOption: selectedOption,
			};

			return updatedSelectedAnswers;
		});
	};

	const handlePrevClick = () => {
		setTabIndex(tabIndex - 1);
	};

	const handleNextClick = () => {
		setTabIndex(tabIndex + 1);
	};

	const handleSubmit = () => {
		if (isResults) {
			navigate(`/labs/${lab_id}/nodes`);
		} else {
			const formData = {
				answers: selectedAnswers,
			};
			const options = {
				method: 'POST',
				url: `/api/labs/${lab_id}/nodes/${node_id}/quiz/submit`,
				headers: {
					accept: 'application/json',
				},
				data: formData,
			};
			axios
				.request(options)
				.then(async function (response) {
					await new Promise((resolve) => setTimeout(resolve, 50)); // Adding a wait for api post to happen
					navigate(`/labs/${lab_id}/nodes/${node_id}/quiz/results`);
					setIsResults(true);
				})
				.catch((err) => {
					let status = err.response.status;
					console.log('error', status);
					navigate('/oops');
				});

		}
	};

	return (
		<div className={Styles.CardContainer}>
			<Backdrop
				open={true}
				style={{
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
					zIndex: 9999,
				}}
			>
				<div className={Styles.QuizContainer}>
					<div className={Styles.title}>
						{quizName} {isResults ? props.t('Labs.QuizForNode.quiz.title.results') :
							props.t('Labs.QuizForNode.quiz.title.attempt')}
					</div>
					<div id="tabsTimerContainer" className={Styles.tabsTimerContainer}>
						<div id="tabsContainer" className={Styles.tabsContainer}>
							<Tabs
								value={tabIndex}
								onChange={handleTabChange}
								TabIndicatorProps={{
									sx: {
										backgroundColor: '#1e88e5',
										height: 3,
										width: 0.1,
									},
								}}
								variant="scrollable"
								scrollButtons="auto"
								centered
							>
								{tabLabels.map((tablabel, index) => (
									<Tab
										id={`questionTabs-${index}`}
										label={
											<div
												id={`tabCircle-${index}`}
												key={index}
												className={Styles.tabCircle}
												style={
													!isResults
														? {
															backgroundColor: selectedAnswers[index] !== -1 ? '#4986d6' : '#f2f2f2',
															color:
																selectedAnswers[index] !== -1
																	? '#fff'
																	: !questions[index].isAttempted
																		? '#000'
																		: '#f2f2f2',
														}
														: {
															backgroundColor: !questions[index].isAttempted
																? '#f5f5f5'
																: questions[index].isCorrect
																	? '#18af89'
																	: '#dc6262 ',
															color: !questions[index].isAttempted ? '#000' : '#f2f2f2',
														}
												}
											>
												{index + 1}
											</div>
										}
										sx={{
											fontWeight: '600',
											'&.Mui-selected': {
												color: '#1e88e5',
											},
										}}
									/>
								))}
							</Tabs>
						</div>
					</div>
					{loading ? (
						<div>
							<LoadingBackdrop isOpen={true} />
						</div>
					) : questions.length > 0 ? (
						<QuizQuestion
							key={questions[tabIndex]}
							question={questions[tabIndex]}
							questionNumber={tabIndex + 1}
							onAnswerSelect={handleAnswerSelect}
							selectedAnswers={selectedAnswers}
							Results={isResults}
						/>
					) : (
						props.t('Labs.QuizForNode.none')
					)}

					<div className={Styles.buttonContainer}>
						<span>
							<QuizForNode
								type={'button'}
								onClick={handlePrevClick}
								condition={tabIndex === 0}
								buttonText={props.t('Labs.QuizForNode.button.prev')}
								showIcon={false}
								showResult={isResults}
							></QuizForNode>
						</span>
						<span>
							<QuizForNode
								type={'button'}
								onClick={handleNextClick}
								condition={tabIndex === tabLabels.length - 1}
								buttonText={props.t('Labs.QuizForNode.button.next')}
								showIcon={false}
								showResult={isResults}
							></QuizForNode>
						</span>
						<Tooltip
							title={isResults ? props.t('Labs.QuizForNode.tooltip.results') :
								props.t('Labs.QuizForNode.tooltip.attempt')}
							arrow
							placement="bottom"
						>
							<span>
								<QuizForNode
									type={'submit'}
									onClick={handleSubmit}
									condition={selectedAnswers.includes(-1) && !isResults}
									buttonText={isResults ? props.t('Labs.QuizForNode.button.back') :
										props.t('Labs.QuizForNode.button.submit')}
									showIcon={!isResults}
									showResult={isResults}
								></QuizForNode>
							</span>
						</Tooltip>
					</div>
				</div>
			</Backdrop>
		</div>
	);
}

const QuizForNode = (props) => {
	return (
		<div className={Styles.navButtonContainer}>
			<button
				type={props.type}
				color="primary"
				disabled={props.condition}
				onClick={props.onClick}
				showIcon={props.showIcon}
			>
				{props.showIcon && <AssignmentTurnedInIcon fontSize="small" sx={{ marginRight: '4px' }} />}
				{props.buttonText}
			</button>
		</div>
	);
};
